import http from './http'
const base = '/Telas/Recorrencia'
export default {
  async getPaged (params) { return (await http.get(`${base}/GetPaged`, { params })).data },
  async getById (id) { return (await http.get(`${base}/GetById/${id}`)).data },
  async getOptions () { return (await http.get(`${base}/GetOptions`)).data },
  async add (input) { return (await http.post(`${base}/Add`, input)).data },
  async update (input) { await http.put(`${base}/Update`, input) },
  async changeStatus (id, status) { await http.post(`${base}/ChangeStatus/${id}/${status}`) },
  async processDue () { return (await http.post(`${base}/ProcessDue?batchSize=20`)).data }
}
